import { render, staticRenderFns } from "./findmyphone.vue?vue&type=template&id=31247544"
import script from "./findmyphone.vue?vue&type=script&lang=js"
export * from "./findmyphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31247544')) {
      api.createRecord('31247544', component.options)
    } else {
      api.reload('31247544', component.options)
    }
    module.hot.accept("./findmyphone.vue?vue&type=template&id=31247544", function () {
      api.rerender('31247544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/findmyphone.vue"
export default component.exports